/* exported Alert */
export const Alert = function (config) {
  this.container =
    typeof config.container === "string"
      ? document.querySelector(config.container)
      : config.container; //Get container to place alert in
  this.alert = document.createElement("div"); //Create alert elements todo: Refactor this when we tested template literals
  this.alert.classList.add("alert"); //Add alert class for base styling

  //Set id if set in config
  if (config.id) {
    this.alert.setAttribute("id", config.id); //Add id to element
  }

  //Set variant (error, success, info)
  this.setVariant = function (variant) {
    this.alert.setAttribute("data-alert-variant", variant);
  };

  //Show alert and prepend to container element
  this.show = function () {
    this.alert.classList.add("d-block");
    this.alert.classList.remove("d-none");

    if (this.container) {
      this.container.prepend(this.alert);
    }
  };

  //Hide alert
  this.hide = function () {
    this.alert.classList.add("d-none");
    this.alert.classList.remove("d-block");
  };

  //Remove the alert element
  this.remove = function () {
    this.alert.remove();
  };

  //Set message of alert
  this.setMessage = function (message) {
    this.alert.innerHTML = message;
  };
};

/*------------------ FUNCTION TO SHOW ALERT ON PAGE LOAD ---------------*/

export const showSingleAlert = function () {
  const alertContainers = document.querySelectorAll("[data-alert=true]"); //Get all containers

  //Loop over all alert containers
  [].forEach.call(alertContainers, function (alertContainer) {
    const alertVariant = alertContainer.getAttribute("data-alert-variant"); //Get alert variant
    let alertMessage = alertContainer.getAttribute("data-alert-msg"); //Get alert message
    const isHtml = alertContainer.hasAttribute("data-alert-isHtml"); //Get attribute to use the innerHtml for message

    if (isHtml) {
      alertMessage = alertContainer.innerHTML; //Get innerHtml for alert message
      alertContainer.innerHTML = ""; //Clear innerHtml from alert container
      alertContainer.classList.remove("d-none");
    }

    if (alertMessage && typeof alertMessage === "string" && alertVariant) {
      const alert = new Alert({ container: alertContainer }); //Create new alert
      alert.setMessage(alertMessage); //Set message
      alert.setVariant(alertVariant); //Set variant
      alert.show(); //Show the alert
    }
  });
};
